export default {
  name: "Utilisateur",
  plural: "Utilisateurs",
};
